import React from 'react';
import PropTypes from 'prop-types';
import Verified from 'components/Badges/Verified/Verified';
import TwineRecommends from 'components/Badges/TwineRecommends/TwineRecommends';
import Pro from 'components/Badges/Pro/Pro';
import styles from './UserStatusBadges.module.scss';

/**
 * Renders Verified or Twine Recommends (mutually exclusive), then Pro.
 * Pass showPro={false} for verified-tier only (e.g. Inbox).
 */
const UserStatusBadges = ({
  user,
  showPro = true,
  iconOnly = false,
  // false for InstantSearch static HTML (e.g. /browse) where OverlayTrigger is stripped
  overlay = true,
  className = '',
  style,
  badgeStyle,
  ...rest
}) => {
  if (!user) {
    return null;
  }

  const hasVerifiedTier = user.twine_recommends || user.verified;
  const hasPro = showPro && user.pro;

  if (!hasVerifiedTier && !hasPro) {
    return null;
  }

  const classNames = [styles.row, className].filter(Boolean).join(' ');

  return (
    <span className={classNames} style={style} {...rest}>
      {user.twine_recommends ? (
        <TwineRecommends
          user={user}
          style={badgeStyle}
          iconOnly={iconOnly}
          overlay={overlay}
        />
      ) : (
        <Verified
          user={user}
          style={badgeStyle}
          iconOnly={iconOnly}
          overlay={overlay}
        />
      )}
      {showPro ? <Pro user={user} style={badgeStyle} /> : null}
    </span>
  );
};

UserStatusBadges.propTypes = {
  user: PropTypes.object,
  showPro: PropTypes.bool,
  iconOnly: PropTypes.bool,
  overlay: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  badgeStyle: PropTypes.object,
};

export default UserStatusBadges;
